/**
 * What the viewer needs from the host's Content-Security-Policy. React-free, so
 * `next.config.ts` can import it.
 *
 * No third-party origin and no `blob:` script: PDFium's wasm ships inside this
 * package and is referenced relatively, so every entry is a capability rather
 * than a host. Each list only matters once the host constrains that directive.
 */
export function pdfCspSources(): {
  imgSrc: string[];
  connectSrc: string[];
  scriptSrc: string[];
  styleSrc: string[];
  workerSrc: string[];
} {
  return {
    // Pages, tiles and thumbnails are all painted as object URLs. Without it
    // every page renders as "image could not be loaded".
    imgSrc: ['blob:'],
    // The engine fetches a document from wherever the HOST points it; this
    // package adds no origin of its own. A buffer source fetches nothing.
    connectSrc: [],
    // PDFium is WebAssembly. Once a host sets `script-src`, compiling it
    // requires this keyword — and this keyword ONLY: it permits
    // `WebAssembly.compile`/`instantiate` without permitting `eval`, so the
    // CVE-2024-4367 class of bug stays shut.
    scriptSrc: ["'wasm-unsafe-eval'"],
    styleSrc: [],
    // EmbedPDF's `new Worker(new URL('./pdfium.worker.ts', …))`, which the
    // bundler emits as a same-origin chunk.
    workerSrc: ["'self'"],
  };
}
